module.exports = __webpack_public_path__ + "static/media/hello_fresh_beehive_nuneaton.bb892dd9.jpg";